import { ArrowRight } from 'lucide-react';

export interface AskAboutThisLinkProps {
  /** `openHelp(sectionKey)` — the bridge from the section popover to the overlay. */
  onClick: () => void;
  label?: string;
}

/** The footer of the navy section popover: a rule, then one action. White label, coral arrow. */
export function AskAboutThisLink({ onClick, label = 'Ask more about this' }: AskAboutThisLinkProps) {
  return (
    <>
      <span aria-hidden="true" className="block h-px bg-white/20" />
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-[7px] self-start text-[12.5px] font-bold text-white focus-visible:rounded focus-visible:ring-[3px] focus-visible:ring-dvaOrange/35 focus-visible:outline-none"
      >
        {label}
        <ArrowRight className="size-[15px] text-dvaOrange" strokeWidth={2.4} aria-hidden="true" />
      </button>
    </>
  );
}
